import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, Router, Switch, useLocation } from "react-router-dom";
import { Layout } from "../Utils/layout";
import BasePage from "./BasePage";
import { AuthPage, Logout } from "./modules/Auth";
import SSO from "./modules/Auth/pages/SSO";
import { Thankyou } from "./modules/Auth/pages/Thankyou";
import ErrorsPage from "./modules/ErrorPages/ErrorsPage";
import history from "./util/history";
import { SnackbarProvider } from "notistack";
import SnackbarCloseButton from "./util/SnackbarCloseButton";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';


export function Routes() {
  const isAuthorized = useSelector(
    ({ auth }) => auth.user != null,
    shallowEqual
  );

  const ssoStatus = useSelector(({ auth }) => auth.sso_status);

  let lastAuthTokenRefreshedTime = useSelector(
    (state) => state.auth.lastAuthTokenRefreshedTime,
    shallowEqual
  );

  const isTokenValid = (lastAuthTokenRefreshedTime) => {
    if (!lastAuthTokenRefreshedTime || lastAuthTokenRefreshedTime === 0) {
      return false;
    }
    let REACT_APP_LOGIN_TOKEN_EXPIRY_IN_MIN =
      process.env.REACT_APP_LOGIN_TOKEN_EXPIRY_IN_MIN * 60 * 1000;
    var d = new Date();
    var n = d.getTime();
    var currentTime = n;

    var expiryTime =
      lastAuthTokenRefreshedTime + REACT_APP_LOGIN_TOKEN_EXPIRY_IN_MIN;
    if (expiryTime > currentTime) {
      return true;
    }
    return false;
  };

  let location = useLocation();

  return (
    <Router history={history}>
      <Switch>
        {location.pathname === "/thankyou" && (
          <Route>
            <Thankyou />
          </Route>
        )}

        {ssoStatus !== 200 && location.pathname === "/sso" && (
          <Route>
            <SSO />
          </Route>
        )}
        {!isAuthorized ? (
          <Route>
            <AuthPage />
          </Route>
        ) : (
          <Redirect from="/login" to="/" />
        )}
        <Route path="/error" component={ErrorsPage} />
        <Route path="/logout" component={Logout} />
        {isAuthorized && !isTokenValid(lastAuthTokenRefreshedTime) && (
          <Redirect to="/logout" />
        )}
        {!isAuthorized ? (
          <Redirect to="/login" />
        ) : (
          <SnackbarProvider
            maxSnack={5}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            action={(snackbarKey) => (
              <SnackbarCloseButton snackbarKey={snackbarKey} />
            )}
            iconVariant={{
              error: <ErrorOutlineIcon style={{ height: 22, width: 22, marginRight: 8 }} />, 
              success: <CheckCircleOutlinedIcon style={{ height: 24, width: 24, marginRight: 8 }}/>
            }}
          >
            <Layout>
              <BasePage />
            </Layout>
          </SnackbarProvider>
        )}
      </Switch>
    </Router>
  );
}
